import "./App.css";
import { lazy, Suspense } from "react";
import { Routes, Route, Navigate, Outlet, useLocation } from "react-router-dom";

import PropertyList from "./components/PropertyList";
import CustomLoader from "./components/CustomLoader";

const PropertyPage = lazy(() => import("./pages/PropertyPage"));
const AddNewProperty = lazy(() => import("./pages/AddNewProperty"));
const LoginScreen = lazy(() => import("./pages/LoginScreen"));
const EditProperty = lazy(() => import("./pages/EditProperty"));

export default function App() {
  return (
    <div className="App">
      <Suspense fallback={<CustomLoader />}>
        <Routes>
          {/* Public route: login */}
          <Route path="login_s" element={<LoginScreen />} />
          <Route path=":uid" element={<PropertyList />} />
          <Route path=":sn/:id/:uid" element={<PropertyPage />} />
          <Route path=":uid/addnewproperty" element={<AddNewProperty />} />
          <Route path=":sn/:id/:uid/edit_page" element={<EditProperty />} />
          <Route path="*" element={<Navigate to="/login_s" replace />} />
        </Routes>
      </Suspense>
    </div>
  );
}
